define('app/dashboard/dialogs/EditDashboardDialogView',['require','app/editor/dialogs/SaveDialogView','config','glu/$','hbs!./EditDashboardDialogView.hbs'],function(require) {
	'use strict';

	var SaveDialogView = require('app/editor/dialogs/SaveDialogView'),
		config = require('config'),
		$ = require('glu/$');

	var view = SaveDialogView.extend({

		dialogTitle: 'Edit Dashboard',

		getClass: function() {
			return 'modal-edit-dashboard';
		},

		template: require('hbs!./EditDashboardDialogView.hbs'),

		ui: {
			$publicFieldId: '#dashboard-as-public',
			$warningSection: '#warningMessage'
		},

		events: {
			'change [id="dashboard-as-public"]': 'checkAccess'
		},

		getName: function() {
			return this.model.get('name');
		},

		getDescription: function() {
			return this.model.get('description');
		},

		isPublic: function() {
			return !this.model.get('isPrivate');
		},

		uigetPublic: function() {
			return this.$el.find(this.ui.$publicFieldId).is(':checked');
		},

		checkAccess: function() {
			if (this.isPublic() && !this.uigetPublic()) {
				this.ui.$warningSection.show();
			} else {
				this.ui.$warningSection.hide();
			}
		},

		save: function() {
			if (this.isValid()) {
				// edit an existing dashboards
				var dashboard = this.model;
				dashboard.set('name', this.uigetName());
				dashboard.set('description', this.uigetDescription());
				dashboard.set('isPrivate', !this.uigetPublic());

				$.ajax(config.apiRoot + 'service/dashboards', {
					type: 'POST',
					context: this,
					contentType: 'application/json',
					data: JSON.stringify(dashboard)
				}).done(function(data) {
					this.trigger('editDashboard', data.id);
				});
			}
		}
	});

	return view;
});

